import { FunctionComponent, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';

import { Colors } from 'src/utils/color';

import DropContainer from './dropContainer';

type Props = {
    onSelect: (file: File) => void;
};
const UploadContainer: FunctionComponent<Props> = ({ onSelect }: Props) => {
    const onDrop = useCallback(
        (acceptedFiles: File[]) => {
            // Update 5/21/25, changed max limit to 5 GB
            // TODO: put it into a centrailzied constant file 
            const maxSizeInBytes = 5 * 1024 * 1024 * 1024;
            if (acceptedFiles[0].size > maxSizeInBytes) {
                alert('file size limit exceeded!');
                return;
            }

            const fileName = acceptedFiles[0].name.toLowerCase();
            if (!fileName.endsWith('.h5') && !fileName.endsWith('.hdf5')) {
                alert('Invalid file type! Only .h5 or .hdf5 files are accepted.');
                return;
            }
            // TODO: shall we support bulk loading later?
            onSelect(acceptedFiles[0]);
        },
        [onSelect]
    );
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop
    });

    return (
        <div {...getRootProps()}>
            <input {...getInputProps()} />
            {isDragActive ? (
                <DropContainer color={Colors.dropdown.menu_item_bg} />
            ) : (
                <DropContainer color={Colors.dropdown.dropdown_bg} />
            )}
        </div>
    );
};

export default UploadContainer;
